const regionMap = {
  "us": "United States",
  "ca": "Canada",
  "br": "Brazil",
  "hk": "Hong Kong",
  "jp": "Japan",
  "mo": "Macao, China",
  "my": "Malaysia",
  "ph": "Philippines",
  "sg": "Singapore",
  "kr": "South Korea",
  "th": "Thailand",
  "vn": "Vietnam",
  "at": "Austria",
  "be": "Belgium",
  "hr": "Croatia",
  "cz": "Czech Republic",
  "dk": "Denmark",
  "ee": "Estonia",
  "fi": "Finland",
  "fr": "France",
  "de": "Germany",
  "gr": "Greece",
  "hu": "Hungary",
  "ie": "Ireland",
  "it": "Italy",
  "lv": "Latvia",
  "lt": "Lithuania",
  "lu": "Luxembourg",
  "nl": "Netherlands",
  "pl": "Poland",
  "pt": "Portugal",
  "sk": "Slovakia",
  "si": "Slovenia",
  "es": "Spain",
  "se": "Sweden",
  "ch": "Switzerland",
  "gb": "United Kingdom",
  "au": "Australia",
  "nz": "New Zealand"
};

export default regionMap;
